import Button from '@material-ui/core/Button';
import styled from 'styled-components';

export const FullBleedButton = styled(Button)`
  padding: 0;
  width: 100%;

  & .MuiButton-label {
    padding: 0 10px;
    justify-content: space-between;
  }
`;
